/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeNewPasswordRequiredResponse
 */
export interface ChallengeNewPasswordRequiredResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    idToken: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    tokenType: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredResponse
     */
    authFlow: ChallengeNewPasswordRequiredResponseAuthFlowEnum;
}


/**
 * @export
 */
export const ChallengeNewPasswordRequiredResponseAuthFlowEnum = {
    Login: 'LOGIN'
} as const;
export type ChallengeNewPasswordRequiredResponseAuthFlowEnum = typeof ChallengeNewPasswordRequiredResponseAuthFlowEnum[keyof typeof ChallengeNewPasswordRequiredResponseAuthFlowEnum];


/**
 * Check if a given object implements the ChallengeNewPasswordRequiredResponse interface.
 */
export function instanceOfChallengeNewPasswordRequiredResponse(value: object): value is ChallengeNewPasswordRequiredResponse {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    if (!('authFlow' in value) || value['authFlow'] === undefined) return false;
    return true;
}

export function ChallengeNewPasswordRequiredResponseFromJSON(json: any): ChallengeNewPasswordRequiredResponse {
    return ChallengeNewPasswordRequiredResponseFromJSONTyped(json, false);
}

export function ChallengeNewPasswordRequiredResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeNewPasswordRequiredResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
        'authFlow': json['authFlow'],
    };
}

export function ChallengeNewPasswordRequiredResponseToJSON(json: any): ChallengeNewPasswordRequiredResponse {
    return ChallengeNewPasswordRequiredResponseToJSONTyped(json, false);
}

export function ChallengeNewPasswordRequiredResponseToJSONTyped(value?: ChallengeNewPasswordRequiredResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
        'authFlow': value['authFlow'],
    };
}

